import React, { useEffect } from 'react'

export default function A7EXCH() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = 'https://embed.tawk.to/684b3a2942a096190ec12d41/1ititmd2n';
    script.charset = 'UTF-8';
    script.setAttribute('crossorigin', '*');

    document.body.appendChild(script);

    return () => {
      // Optional: Cleanup the script on unmount
      document.body.removeChild(script);
    };
  }, []);

  return null; // No UI is rendered by this component
};

